import { lazyPage } from './lazyPage';
import type { AppRoute } from './types';

const ModuleMenu = lazyPage(() => import('@/pages/ModuleMenu'));
const Enquiries = lazyPage(() => import('@/pages/admissions/Enquiries'));
const Applicants = lazyPage(() => import('@/pages/admissions/Applicants'));
const ApplicantVerification = lazyPage(() => import('@/pages/admissions/ApplicantVerification'));
// const ApplicationForms = lazyPage(() => import('@/pages/admissions/ApplicationForms'));
const ApplicationFormDesign = lazyPage(() => import('@/pages/admissions/ApplicationFormDesign'));
const EntranceTest = lazyPage(() => import('@/pages/admissions/EntranceTest'));
const Counselling = lazyPage(() => import('@/pages/admissions/Counselling'));
const InteractionManagement = lazyPage(() => import('@/pages/admissions/InteractionManagement'));
const Selection = lazyPage(() => import('@/pages/admissions/Selection'));
const AdmissionApproval = lazyPage(() => import('@/pages/admissions/AdmissionApproval'));
const AdmissionFeePayment = lazyPage(() => import('@/pages/admissions/FeePayment'));
const AdmissionEnrollment = lazyPage(() => import('@/pages/admissions/Enrollment'));
const WaitingList = lazyPage(() => import('@/pages/admissions/WaitingList'));
const AdmissionReports = lazyPage(() => import('@/pages/admissions/Reports'));

export const admissionsRoutes: AppRoute[] = [
  {
    path: 'admissions',
    title: 'Admission',
    children: [
      { path: '', title: 'Admission', component: ModuleMenu },
      { path: 'enquiries', title: 'Enquiries', component: Enquiries, yearScoped: true },
      { path: 'applicants/:applicantId/verification', title: 'Applicant Verification', component: ApplicantVerification, yearScoped: true },
      // { path: 'application-forms', title: 'Application Forms', component: ApplicationForms },
      
      
      { path: 'application-form', title: 'Application Form', component: ApplicationFormDesign, yearScoped: true },
      // A saved application (a draft, or a filed form being corrected) reopened in the application form.
      { path: 'application-form/:applicantId', title: 'Application Form', component: ApplicationFormDesign, yearScoped: true },
      { path: 'applicants', title: 'Applicants', component: Applicants, yearScoped: true },
      { path: 'entrance-test', title: 'Entrance Test', component: EntranceTest, yearScoped: true },
      // Interview is now a tab of Counselling, not its own menu entry — redirect any old links.
      { path: 'interview', title: 'Interview', redirectTo: '/administrator/admissions/counselling?tab=interview' },
      { path: 'counselling', title: 'Counselling', component: Counselling, yearScoped: true },
      { path: 'interactions', title: 'Interaction Management', component: InteractionManagement, yearScoped: true },
      { path: 'selection', title: 'Selection', component: Selection, yearScoped: true },
      { path: 'approval', title: 'Admission Approval', component: AdmissionApproval, yearScoped: true },
      { path: 'fee-payment', title: 'Fee Payment', component: AdmissionFeePayment, yearScoped: true },
      { path: 'enrollment', title: 'Enrollment', component: AdmissionEnrollment, yearScoped: true },
      { path: 'waiting-list', title: 'Waiting List', component: WaitingList, yearScoped: true },
      { path: 'reports', title: 'Admission Reports', component: AdmissionReports, yearScoped: true },
    ],
  },
];
